import React from 'react';
import { Text, View, StyleSheet, Image } from 'react-native';
import { Button } from '../../components';
import AargauerZeitung from '../../assets/images/press/logos/aargauer-zeitung.png';
import BernerZeitung from '../../assets/images/press/logos/berner-zeitung.png';
import Blick from '../../assets/images/press/logos/blick.png';
import Brigitte from '../../assets/images/press/logos/brigitte.png';
import GrosselternMagazin from '../../assets/images/press/logos/grosseltern-magazin.jpg';
import NZZamSonntag from '../../assets/images/press/logos/nzz-am-sonntag.png';
import Radio1 from '../../assets/images/press/logos/radio1.jpg';
import SchweizerFamilie from '../../assets/images/press/logos/schweizer-familie.png';
import SRF1 from '../../assets/images/press/logos/srf1.png';
import Suedostschweiz from '../../assets/images/press/logos/suedostschweiz.png';
import TeleBaern from '../../assets/images/press/logos/tele-baern.png';
import ZentralschweizAmSonntag from '../../assets/images/press/logos/zentralschweiz-am-sonntag.png';
import ArticleBrigitte from '../../assets/images/press/articles/brigitte.jpg';
import ArticleGrosselternMagazin from '../../assets/images/press/articles/grosseltern-magazin.jpg';
import ArticleNZZamSonntag from '../../assets/images/press/articles/nzz-am-sonntag.jpg';
import ArticleRadio1 from '../../assets/images/press/articles/radio1.mp3';
import ArticleSchweizerFamilie from '../../assets/images/press/articles/schweizer-familie.pdf';
import ArticleZentralschweizAmSonntag from '../../assets/images/press/articles/zentralschweiz-am-sonntag.pdf';
import ArticleSRF from '../../assets/images/press/articles/srf.jpg';
import { useHistory } from 'react-router-dom';
import TiltedImageLayout from '../../components/layouts/TiltedImageLayout';
import Section from '../../components/sections/Section';
import { H2 } from '../../components/UI/TextStyles';

const styles = StyleSheet.create({
  title: {
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'start',
    marginVertical: 20,
  },
  copy: {
    fontSize: 'large',
    lineHeight: 'large',
    maxWidth: 500,
    width: '100%',
  },
});

function Press() {
  const history = useHistory();
  const images = [
    {
      name: 'Blick',
      logo: Blick,
      href:
        'https://www.blick.ch/news/wirtschaft/margrit-als-alternative-zur-kantine-zmittag-bei-fremden-id4756039.html',
    },
    {
      name: 'Aargauer Zeitung',
      logo: AargauerZeitung,
      href:
        'http://www.aargauerzeitung.ch/leben/leben/keine-lust-mehr-auf-die-firmen-kantine-dann-gehen-sie-doch-zu-gerda-130103868',
    },
    {
      name: 'Zentralschweiz am Sonntag',
      logo: ZentralschweizAmSonntag,
      href: ArticleZentralschweizAmSonntag,
    },
    {
      name: 'NZZ am Sonntag',
      logo: NZZamSonntag,
      href: ArticleNZZamSonntag,
    },
    {
      name: 'Grosseltern-Magazin',
      logo: GrosselternMagazin,
      href: ArticleGrosselternMagazin,
    },
    {
      name: 'Schweizer Familie',
      logo: SchweizerFamilie,
      href: ArticleSchweizerFamilie,
    },
    {
      name: 'Radio 1',
      logo: Radio1,
      href: ArticleRadio1,
    },
    {
      name: 'Brigitte',
      logo: Brigitte,
      href: ArticleBrigitte,
    },
    {
      name: 'Berner Zeitung',
      logo: BernerZeitung,
      href: 'http://mobile2.12app.ch/articles/27179890',
    },
    {
      name: 'SRF 1',
      logo: SRF1,
      href: ArticleSRF,
    },
    {
      name: 'Die Südostschweiz',
      logo: Suedostschweiz,
      href:
        'http://www.suedostschweiz.ch/leben/2016-08-10/am-mittagstisch-wie-bei-oma',
    },
    {
      name: 'Tele Bärn',
      logo: TeleBaern,
      href:
        'http://www.telebaern.tv/118-show-news/10325-episode-mittwoch-18-mai-2016/23210-segment-alternative-zu-take-away-und-kantine',
    },
  ];
  return (
    <View style={{ padding: 10 }}>
      <H2 centered>Bekannt aus:</H2>
      <Text style={{ textAlign: 'center', fontSize: 'large', marginTop: 30 }}>
        Das sagen andere über Triff (ehemals: Margrit).
      </Text>
      <View
        style={{
          flexWrap: 'wrap',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'center',
        }}
      >
        {images.map(image => (
          <a
            href={image.href}
            key={image.logo}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              alt={image.name}
              source={image.logo}
              style={{ width: 150, height: 150, margin: 20 }}
              resizeMode="contain"
            />
          </a>
        ))}
      </View>
    </View>
  );
}

export default Press;
